// core
import React from "react";
import {
    ClientProductTypes,
    ProductType
} from "../../../common/interfaces/enums/ProductType";
import BaseProductSettings from "../../components/Products/BaseProductSettings";
import { IClientSettingsBoxProduct } from "../../components/Clients/ClientSettingsBox/ClientSettingsBox";
import ClientSettingsBoxLife from "../../components/Clients/ClientSettingsBoxLife/ClientSettingsBoxLife";
import ClientSettingsBoxTrauma from "../../components/Clients/ClientSettingsBoxTrauma/ClientSettingsBoxTrauma";
import ClientSettingsBoxHealth from "../../components/Clients/ClientSettingsBoxHealth/ClientSettingsBoxHealth";
import ClientSettingsBoxIncome from "../../components/Clients/ClientSettingsBoxIncome/ClientSettingsBoxIncome";
import ClientSettingsBoxMortgage from "../../components/Clients/ClientSettingsBoxMortgage/ClientSettingsBoxMortgage";
import GlobalProductForm from "../../components/SettingForms/GlobalProductForm";
import { useFormikContext } from "formik";
import { IQuoteSettings } from "../../interfaces/form/IQuoteSettings";
import cx from "classnames";
import SettingsDisplayType from "../../enums/SettingsDisplayType";

interface IProductFormContainerProps {
    className?: string;
    productType: ClientProductTypes;
    style?: SettingsDisplayType;
    onSubmit?: () => Promise<void>;
    onCancel?: () => Promise<void>;
}

const ClientComponent: {
    [key in ProductType]: React.FC<IClientSettingsBoxProduct>;
} = {
    [ProductType.Life]: ClientSettingsBoxLife,
    [ProductType.Trauma]: ClientSettingsBoxTrauma,
    [ProductType.Health]: ClientSettingsBoxHealth,
    [ProductType.Income]: ClientSettingsBoxIncome,
    [ProductType.Mortgage]: ClientSettingsBoxMortgage,
    [ProductType.WaiverOfPremium]: null
};

const ProductFormContainer: React.FC<IProductFormContainerProps> = (
    props
): React.ReactElement => {
    const { productType, children } = props;
    const style = props.style || SettingsDisplayType.Card;
    const RenderComponent = ClientComponent[productType];

    const { values } = useFormikContext<IQuoteSettings>();

    if (!RenderComponent) return null;

    return (
        <React.Fragment>
            <div className="padding-horizontal-2xl">
                <GlobalProductForm productType={productType} />
            </div>
            <BaseProductSettings
                productType={productType}
                isChildClientAllowed={productType === ProductType.Health}
                className={cx({
                    "gap-m": style === SettingsDisplayType.Card
                })}
                style={style}>
                {({ index, name, setClient }) => {
                    return (
                        <RenderComponent
                            className={cx({
                                ["panel-card"]: style === SettingsDisplayType.Card
                            })}
                            client={values.clients[index]}
                            name={name}
                            setClient={setClient}
                        />
                    );
                }}
            </BaseProductSettings>
            {children}
        </React.Fragment>
    );
};

export default ProductFormContainer;
